import styled from 'styled-components';

export const AnimationContainer = styled.div`
  width: 40vw;
  height: 500px;
  position: relative;
  border-radius: 20px;
  margin-top: 100px;
`;